import { useEffect } from "react"
import lottie from "lottie-web"

export function useLottie(
  ref: React.MutableRefObject<HTMLDivElement>,
  data: any
) {
  useEffect(() => {
    setTimeout(() => {
      if (!ref.current?.hasChildNodes())
        lottie.loadAnimation({
          //@ts-ignore
          container: ref.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: data,
        })
    }, 500)
  }, [])
}
